import styled from "@emotion/styled";

import { formatGenericDate, isFutureDate } from "../../../utils/util";

import { lighten, darken } from "@mui/material/styles";

const Label = styled.div`
  background-color: ${props => lighten(props.theme.colors.info, 0.94)};
  color: ${props => darken(props.theme.colors.info, .3)};
  border-radius: 3px;
  padding: .4rem 1rem;
  font-weight: 500;
  font-size: 1.6rem;
  width: fit-content;
`

const WeddingDate =({date}) => {
  if (!date || !isFutureDate(date)) return null;
  return (
    <Label>
     Wedding {formatGenericDate(date, "short")}
    </Label>
  )
};

export default WeddingDate;